import { EventColorCategory } from "@clockwise/client-commons/src/util/event-category-coloring";
import { Select, SelectOption, SelectOptionsGroup } from "@clockwise/design-system";
import { Settings } from "@clockwise/design-system/icons";
import { bg_info_emphasis } from "@clockwise/design-system/tokens";
import { CropSquareFilled } from "@clockwise/icons";
import { formatEventTitle } from "@clockwise/web-commons/src/components/calendar/calendar-event/utils/formatEventTitle";
import { getUrlForFeature } from "@clockwise/web-commons/src/util/routes.util";
import { Launch } from "@material-ui/icons";
import classNames from "classnames";
import React from "react";
import { CategoryOption } from "../../web-app-calendar/hooks/useEventDetails";
import { Async } from "../atoms/Async";

const _openColorSettingsLink = (url: string) => {
  window.open(url, "_blank");
};

export const ECTitle = ({
  eventName,
  onEventNameChange,
  readOnly,
  loading = false,
  allColorSettings = [],
  onCategoryChange,
  currentCategory,
  locked,
}: {
  eventName: string;
  onEventNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  readOnly: boolean;
  loading?: boolean;
  allColorSettings?: CategoryOption[];
  currentCategory?: EventColorCategory;
  onCategoryChange?: (value: EventColorCategory) => void;
  locked?: boolean;
}) => {
  const showCategories = Boolean(allColorSettings?.length);

  const onCategorySelection = (value: EventColorCategory) => {
    onCategoryChange?.(value);
  };

  const routeToColorSettings = () => {
    const url = getUrlForFeature("preferences", { hash: "#colorCoding", relative: true });
    _openColorSettingsLink(url);
  };

  return (
    <div className="cw-border-none">
      <div className="cw-py-2 cw-pr-3 cw-pl-2 cw-flex cw-border-solid cw-border-b cw-border-subtle cw-items-center cw-justify-between cw-gap-2">
        <Async loading={loading} loadingHeight="28px">
          <input
            disabled={readOnly}
            className={classNames(
              "cw-p-1 cw-h-7 cw-body-base cw-flex-1 cw-rounded-lg cw-font-semibold disabled:cw-bg-default",
              { "cw-border-none": readOnly },
              {
                "cw-border-[#fff] cw-border-solid cw-border hover:cw-border-subtle cw-outline-positive-emphasis": !readOnly,
              },
            )}
            value={eventName}
            placeholder={formatEventTitle(undefined, locked)}
            onChange={onEventNameChange}
            aria-label="Event title"
          />
        </Async>
        {showCategories && !locked && (
          <Async loading={loading} loadingHeight="28px" loadingWidth="200px">
            <Select size="mini" value={currentCategory} onChange={onCategorySelection}>
              <SelectOptionsGroup label="Meeting category">
                {allColorSettings.map((setting) => {
                  return (
                    <SelectOption
                      icon={CropSquareFilled}
                      iconProps={{
                        style: { color: setting.color || bg_info_emphasis },
                      }}
                      value={setting.category}
                      key={setting.label}
                    >
                      {setting.label}
                    </SelectOption>
                  );
                })}
              </SelectOptionsGroup>
              <SelectOption icon={Settings} value={routeToColorSettings}>
                Edit category colors
                <Launch className="cw-w-4 cw-h-4 cw-text-muted" />
              </SelectOption>
            </Select>
          </Async>
        )}
      </div>
    </div>
  );
};
